import { Instagram, Copy } from "lucide-react";
import { toast } from "sonner";
import { EVENT_CONFIG } from "@/config/eventConfig";
import { SectionHeading, Reveal } from "./shared";

const SocialWall = () => {
  const { images, hashtags, org } = EVENT_CONFIG;

  const posts = [
    { src: images.gownGroup, caption: "The crew showed UP" },
    { src: images.paddleRaise, caption: "Paddles up for the kids" },
    { src: images.checkin, caption: "Red carpet check-in" },
    { src: images.receptionFlowers, caption: "Cocktail hour glow" },
    { src: images.paddles, caption: "Fundraising moment energy" },
    { src: images.danceFloor, caption: "Crown stayed on all night" },
  ];

  const copyTags = async () => {
    try {
      await navigator.clipboard.writeText(hashtags.join(" "));
      toast.success("Hashtags copied — see you on the wall.");
    } catch {
      toast.info(hashtags.join(" "));
    }
  };

  return (
    <section id="social" data-testid="social-wall-section" className="relative py-24 sm:py-32 bg-ink grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-12">
        <SectionHeading
          chapter="10"
          eyebrow="The Social Wall"
          title={
            <>
              SHOW US YOUR <span className="gold-shimmer">CROWN.</span>
            </>
          }
          sub="What are you wearing to Adult Prom? Post your look, your prep, your people — and tag the movement."
        />

        <div className="columns-2 md:columns-3 gap-4 w-full [column-fill:balance]">
          {posts.map((p, i) => (
            <Reveal key={p.src} delay={i * 0.05} className="mb-4 break-inside-avoid">
              <figure className="group relative overflow-hidden rounded-2xl gold-stroke">
                <img
                  src={p.src}
                  alt={p.caption}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-108 group-hover:scale-110"
                />
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-ink/90 to-transparent p-4 flex items-center gap-2">
                  <Instagram size={13} className="text-champagne shrink-0" />
                  <span className="text-cream text-xs">{p.caption}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal className="flex flex-col items-center gap-5">
          <div className="flex flex-wrap justify-center gap-3">
            {hashtags.map((h) => (
              <span key={h} className="px-4 py-2 rounded-full bg-wine/40 border border-winelight text-champagne text-xs sm:text-sm tracking-wide">
                {h}
              </span>
            ))}
          </div>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              data-testid="social-copy-hashtags-button"
              onClick={copyTags}
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border border-champagne/50 text-champagne text-xs uppercase tracking-[0.2em] font-semibold hover:bg-champagne/10 transition-colors"
            >
              <Copy size={14} /> Copy Hashtags
            </button>
            <a
              data-testid="social-instagram-button"
              href={org.socials.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gradient-to-r from-gold via-champagne to-gold text-ink text-xs uppercase tracking-[0.2em] font-bold"
            >
              <Instagram size={14} /> Follow @styles4kidznfp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default SocialWall;
